// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { product2by3ProductStyles, productCarouselProductStyles } from "@gcg/Overrides/Components/ProductCarouselProduct";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

productCarouselProductStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
        &&& span.atc-label {
            font-size: 14px;
        }
    `,
};

productCarouselProductStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "text.main",
        typographyProps: {
            size: 14,
            weight: "normal",
            lineHeight: "20px",
            css:css`
            //XNG-Change
            &&& {
                &:hover,
                &:focus {
                    color: ${getColor("common.ui9")} ;
                }
            }
            `
        },
        css: css`
            margin-bottom: 5px;
            min-height: 60px;
            display: flex;
            align-items: flex-start;
        `,
    },
    productDetailDescription: {
        size: 14,
        weight: "normal",
        lineHeight: "20px",
        css: css`
            margin-bottom: 5px;
            min-height: 60px;
            display: flex;
            align-items: flex-start;
        `,
    },
};

product2by3ProductStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
        &&& span.atc-label {
            font-size: 14px;
        }
    `,
};

product2by3ProductStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "text.main",
        typographyProps: {
            size: 14,
            weight: "normal",
            lineHeight: "17px",
            css:css`
            //XNG-Change
            &&& {
                &:hover,
                &:focus {
                    color: ${getColor("common.ui9")} ;
                }
            }
            `
        },
        css: css`
            margin-bottom: 7px;
            min-height: 51px;
            display: flex;
            align-items: flex-start;
        `,
    },
    productDetailDescription: {
        size: 14,
        weight: "normal",
        lineHeight: "17px",
        css: css`
            margin-bottom: 7px;
            min-height: 51px;
            display: flex;
            align-items: flex-start;
        `,
    },
};